import { NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SiteSvgsComponent } from '@curbnturf/custom-svgs/src/lib/site-svgs/site-svgs.component';
import { Boondock, ILandType, LandType, Listing } from '@curbnturf/entities';

@Component({
  selector: 'curbnturf-listing-description',
  templateUrl: './listing-description.component.html',
  styleUrls: ['./listing-description.component.scss'],
  standalone: true,
  imports: [NgFor, SiteSvgsComponent],
})
export class ListingDescriptionComponent {
  @Input() listing: Listing | Boondock;

  landTypesEnums = LandType;

  terrainName(landType: ILandType['type']): string {
    return this.landTypesEnums[landType];
  }
}
